<template>

<!-- Modal -->
<div>


<div class="modal modal-mask" id="confirmBoxModal" style="display: block">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content ">
      <div style="color:red" class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">
            <i style="color:red" class="fas fa-exclamation-circle mr-3" aria-hidden="true"></i>     
             <slot name="header"></slot>  
        </h4> 

        
      </div>
      <div style="color:black" class="modal-body">
        <slot name="body1"></slot> 
        <slot name="body2"></slot>        
      </div>
      <div class="modal-footer">
         <slot name="footer"></slot>   
        

      </div>
    </div>
  </div>
</div>


</div>
</template>
<script>


export default {
   //props : ['title','msg'],
  components: {},
  data() {
    return {}
  },

  created()
  {
    
  
    
  }, 
  methods: 
  {
  }  
    
   

}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 18px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}

.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-footer {  
  justify-content: space-between;  
}


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
</style>


